import React from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';

import LockedVideo from '../videoComponents/LockedVideo';

import '../../css/player.css';

class SimpleVideoPlayer extends React.Component {
    constructor(props) {
        super(props);
    }

    playButton = () => {
      if (this.player) {
        this.player.play();
      }
    }

    initVideoJs = () => {
      const { clip } = this.props.audition;
      const { clipUrls, defaultClipUrl } = clip || {};

      if(!clipUrls && !defaultClipUrl) {
        return;
      }


        this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
          const clipUrl = clipUrls ? clipUrls.SIZE_720 : undefined;
          const src = clipUrl || defaultClipUrl;
          
          if(src) {
            this.src(src);
          }      
        });
    }
  
    componentDidMount() {
      this.initVideoJs();
    }

    // destroy player on unmount
    componentWillUnmount() {
      if (this.player) {
        this.player.dispose()
      }
    }

    render() {
      const { audition } = this.props;

      const videoAvailable = audition.clip.clipUrls || audition.clip.defaultClipUrl;

        return (
        <div className='masthead '>
            {videoAvailable ?
            <div className='container'>
              <div id="video-player-container" className="clearfix video-player-container preview">
                  <div className="full-player">
                      <div className="player-zone">
                          <div className="video-player">
                              <div id="vp_18">
                                  <div id="vp_18_wrapper" className="sk-video-player">
                                    <video
                                      controls
                                      ref={ node => this.videoNode = node }
                                      id="vp_18_video_html5_api"
                                      className="video-js vjs-sk vjs-default-skin vjs-paused vp_18_video-dimensions vjs-fluid vjs-controls-enabled vjs-workinghover vjs-v6 vjs-user-active"
                                      preload="none"
                                      poster={audition.clip.imageUrl}
                                      playinline=""
                                      tabIndex="-1"
                                    />
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
            :
            <LockedVideo
              videoElement={{imageUrl: audition.clip ? audition.clip.imageUrl : ""}}
              slug={audition.slug}
              customBackgroundColor="#fff"
            />}
          </div>
        );
    }
}
export default SimpleVideoPlayer;
